import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

const PUBLIC_BASE_URL = process.env.REACT_APP_PUBLIC_BASE_URL;

export const getRemainingTickets = createAsyncThunk(
  'ticket/getRemainingTickets',
  async ({ code, skip, limit, draw_date, draw_no }, { rejectWithValue }) => {
    try {
      const config = {
        headers: {
          'Content-Type': 'application/json',
        },
        withCredentials: true,
        params: {
          ...(code ? { code } : {}),
          ...(skip ? { skip: skip - 1 } : {}),
          ...(limit ? { limit } : {}),
          ...(draw_date ? { draw_date } : {}),
          ...(draw_no ? { draw_no } : {}),
        },
      };

      const response = await axios.get(
        `${PUBLIC_BASE_URL}/tickets/get-remaining-tickets`,
        config
      );
      return response.data;
    } catch (err) {
      if (err.message === 'Network Error') {
        return rejectWithValue({
          response: {
            data: {
              message: 'Network Error',
              status: err.code,
              statusText: err.code,
            },
          },
        });
      } else {
        return rejectWithValue(
          err.response?.data?.message || 'An error occurred'
        );
      }
    }
  }
);

export const completeRemainingTickets = createAsyncThunk(
  'ticket/completeRemainingTickets',
  async (data, { rejectWithValue }) => {
    try {
      const config = {
        headers: {
          'Content-Type': 'application/json',
        },
        withCredentials: true,
      };

      const body = JSON.stringify(data);

      const response = await axios.post(
        `${PUBLIC_BASE_URL}/tickets/complete-lottery`,
        body,
        config
      );
      return response.data;
    } catch (err) {
      if (err.message === 'Network Error') {
        return rejectWithValue({
          response: {
            data: {
              message: 'Network Error',
              status: err.code,
              statusText: err.code,
            },
          },
        });
      } else {
        return rejectWithValue(
          err.response?.data?.message || 'An error occurred'
        );
      }
    }
  }
);

export const downloadRemainingTickets = createAsyncThunk(
  'ticket/downloadRemainingTickets',
  async ({ code, draw_date, draw_no }, { rejectWithValue }) => {
    try {
      const config = {
        headers: {
          'Content-Type': 'application/json',
        },
        withCredentials: true,
        params: {
          ...(code ? { code } : {}),
          ...(draw_date ? { draw_date } : {}),
          ...(draw_no ? { draw_no } : {}),
        },
      };

      const response = await axios.get(
        `${PUBLIC_BASE_URL}/tickets/get-remaining-ticket-list-download`,
        config
      );
      if (response.status === 200) {
        downloadReport(response.data, `${code}-${draw_no ? draw_no : draw_date}.csv`);
      }
      return response.data;
    } catch (err) {
      if (err.message === 'Network Error') {
        return rejectWithValue({
          response: {
            data: {
              message: 'Network Error',
              status: err.code,
              statusText: err.code,
            },
          },
        });
      } else {
        return rejectWithValue(
          err.response?.data?.message || 'An error occurred'
        );
      }
    }
  }
);

const downloadReport = (blob, filename) => {
  const url = window.URL.createObjectURL(new Blob([blob]));
  const a = document.createElement('a');
  a.style.display = 'none';
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  window.URL.revokeObjectURL(url);
};
